if (!String.prototype.replaceAll) {
	String.prototype.replaceAll = function (search: string | RegExp, replacement: any) {
		return this.replace(new RegExp(search, "gu"), replacement);
	};
}

export {};
